export default __webpack_public_path__ + "static/media/ReportCenter.48affbd7.svg";